export const IMPORTANCE = { CRITICAL: "Kritik", HIGH: "Yüksek", MEDIUM: "Orta", LOW: "Düşük" };
export const REQUIREMENT = { REQUIRED: "Zorunlu", PREFERRED: "Tercih", BONUS: "Artı" };
export const EVAL_TYPE = { SCALE: "Ölçek (1–5)", BINARY: "Evet / Hayır", NUMERIC_THRESHOLD: "Sayısal", QUALITATIVE: "Nitel" };
export const STUDY_STATUS = { DRAFT: "Taslak", ACTIVE: "Aktif", CLOSED: "Kapandı" };
export const ASSIGNMENT_STATUS = {
  NOT_STARTED: "Başlamadı",
  IN_PROGRESS: "Devam Ediyor",
  SUBMITTED: "Tamamlandı",
  REVOKED: "Devre Dışı",
};
export const CANDIDATE_STATE = { PENDING: "Bekliyor", IN_PROGRESS: "Devam Ediyor", COMPLETED: "Değerlendirildi" };
export const AUDIT_EVENT = {
  STUDY_CREATED: "Değerlendirme oluşturuldu",
  STUDY_DELETED: "Değerlendirme silindi",
  STUDY_LAUNCHED: "Değerlendirme başlatıldı",
  JOB_UPDATED: "İlan güncellendi",
  CV_UPLOADED: "CV yüklendi",
  CANDIDATE_REMOVED: "Aday kaldırıldı",
  CANDIDATES_ADDED_ACTIVE: "Aktif değerlendirmeye aday eklendi",
  RUBRIC_CREATED: "Kriter seti donduruldu",
  RUBRIC_UPDATED: "Kriterler güncellendi",
  ASSIGNMENT_CREATED: "Değerlendirici atandı",
  ASSIGNMENT_OPENED: "Bağlantı açıldı",
  ASSIGNMENT_REVOKED: "Bağlantı devre dışı bırakıldı",
  ASSIGNMENT_LINK_REGENERATED: "Bağlantı yenilendi",
  ASSIGNMENT_ACCESS_CODE_SET: "Erişim şifresi oluşturuldu",
  ASSIGNMENT_ACCESS_CODE_REMOVED: "Erişim şifresi kaldırıldı",
  ASSIGNMENT_UNLOCKED: "Erişim şifresi doğrulandı",
  CANDIDATE_EVALUATION_UPDATED: "Aday puanı güncellendi",
  RANKING_UPDATED: "Sıralama güncellendi",
  CATEGORY_RANKING_UPDATED: "Kategori önceliği güncellendi",
  EVALUATION_SUBMITTED: "Değerlendirme gönderildi",
  EVALUATION_REOPENED: "Değerlendirme yeniden açıldı",
  CATEGORY_DESCRIPTIONS_REFRESHED: "Kategori açıklamaları güncellendi",
  EXPORT_CREATED: "Veri dışa aktarıldı",
};
export const TIERS = { DECISIVE: "Belirleyici", IMPORTANT: "Önemli", MINOR: "Az önemli", IRRELEVANT: "İlgisiz" };
export const SCALE_LABELS = { 1: "Zayıf", 5: "Çok Güçlü" };
export const DEFAULT_GUIDE = {
  1: "Beklentinin çok altında",
  2: "Sınırlı uyum",
  3: "Beklentiyi karşılıyor",
  4: "Güçlü uyum",
  5: "Çok güçlü uyum",
};
